module.exports = __webpack_public_path__ + "img/facebook.03878ec2.svg";